import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import { bool, oneOfType, string, number, func } from 'prop-types';
import { Line, Multiline } from './input.styles';
const Input = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    value,
    onChange
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "value", "onChange"]);

  const Component = props.multiline ? Multiline : Line;
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, props, {
    value: value,
    onChange: e => onChange(e, value)
  }), children);
});
Input.defaultProps = {
  multiline: false,
  hasError: false,
  onChange: () => {}
};
process.env.NODE_ENV !== "production" ? Input.propTypes = {
  multiline: bool,
  hasError: bool,
  children: bool,
  value: oneOfType([string, number]),
  onChange: func
} : void 0;
Input.displayName = 'Input';
export default Input;